import {createStore,combineReducers,applyMiddleware} from 'redux'
import thunk from 'redux-thunk';
import userReducer from './user/reducer.js'
export default createStore(
    combineReducers({
        user:userReducer,
    }),
    applyMiddleware(thunk)
)


// WEBPACK FOOTER //
// ./src/store/index.js